
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/condense-image",
      function () {
        return require("private-next-pages/condense-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/condense-image"])
      });
    }
  